<template>
  <div
    class="v2-wishlist-card-brand"
    @click="goToProducts"
  >
    <div class="v2-wishlist-card-brand__image">
      <img
        :src="getLogo"
        :alt="wishlist.retailerName"
        class="v2-wishlist-card-brand__img"
        @error="onImageError"
      >
    </div>
    <div class="v2-wishlist-card-brand__body">
      <div class="v2-wishlist-card-brand__name">
        {{ wishlist.retailerName }}
      </div>
      <div class="v2-wishlist-card-brand__collection v2-mt-1">
        {{ wishlist.collectionName }}
      </div>
      <div class="v2-wishlist-card-brand__count">
        {{ wishlist.count || 0 }} product{{ wishlist.count > 1 ? 's' : '' }}
      </div>
      <div
        v-if="isBrand && (isEntityAdmin || isSalesManager) && wishlist.salesRep"
        class="v2-wishlist-card-brand__meta v2-mt-1"
      >
        Sales rep: {{ wishlist.salesRep }}
      </div>
      <v2-button
        variant="outline"
        size="sm"
        class="v2-mt-2"
        @click.stop="$emit('open-wishlist-notification', wishlist.retailerName, wishlist.retailerEmail)"
      >
        Send a Message
      </v2-button>
    </div>
  </div>
</template>

<script>
import { getDefaultProductImage } from '@/@core/utils/utils'
import V2Button from '@/components/v2/V2Button.vue'
import UserRoleMixin from '../../apps/UserRoleMixin.vue'

export default {
  name: 'V2WishlistCardForBrand',
  components: { V2Button },
  mixins: [UserRoleMixin],
  props: {
    wishlist: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      defaultCollectionImage: getDefaultProductImage(300, 300),
    }
  },
  computed: {
    getLogo() {
      return this.wishlist.retailerLogo || this.wishlist.collectionLogo || this.defaultCollectionImage
    },
  },
  methods: {
    onImageError(event) {
      event.target.src = this.defaultCollectionImage
    },
    goToProducts() {
      this.$router.push({
        name: 'v2-selection-products',
        params: { wishlistId: this.wishlist._id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-wishlist-card-brand {
  // Tinted glass without backdrop-filter — matches V2WishlistCard for grid
  // consistency. Per-card blur removed for scroll perf (note #3 in
  // glassmorphism-migration-plan.md).
  background: var(--v2-glass-surface-1);
  border: 1px solid var(--v2-glass-stroke);
  border-radius: var(--v2-radius-lg);
  box-shadow: var(--v2-glass-shadow);
  overflow: hidden;
  cursor: pointer;
  contain: layout;
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;

  &:hover {
    border-color: var(--v2-glass-stroke-strong);
    transform: translateY(-1px);
  }

  &__image {
    aspect-ratio: 4 / 3;
    overflow: hidden;
    background: var(--v2-muted);
  }

  &__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__body {
    padding: var(--v2-space-3) var(--v2-space-4);
  }

  &__name {
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--v2-foreground);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__collection {
    font-size: 0.75rem;
    color: var(--v2-muted-foreground);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__count {
    font-size: 0.75rem;
    color: var(--v2-muted-foreground);
  }

  &__meta {
    font-size: 0.75rem;
    color: var(--v2-muted-foreground);
  }
}
</style>
